export default "__VITE_ASSET__d1d1437b__"